import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import LowInventoryPoolsTable from "./LowInventoryPoolsTable";
import { fetchWithToken } from "../../../apiUtils";

const useStyles = makeStyles({
  table: {
    paddingTop: 65,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const Dashboard = ({ isAdmin }) => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    pools: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Pools/LowInventory")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          pools: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <LowInventoryPoolsTable
            isAdmin={isAdmin}
            data={dataObj.pools}
            title={"Low Inventory Pools"}
          />
        </div>
      )}
    </>
  );
};

export default Dashboard;
